
// document.addEventListener("DOMContentLoaded", function () {

//   const buttons = document.querySelectorAll('.target-btn');
//   const groups = document.querySelectorAll('.target-group');

//   buttons.forEach(button => {
//     button.addEventListener('click', function () {

//       // active button
//       buttons.forEach(btn => btn.classList.remove('active'));
//       this.classList.add('active');

//       const target = this.dataset.target;

//       // switch groups
//       groups.forEach(group => {
//         if (group.dataset.group === target) {
//           group.style.display = 'grid';
//         } else {
//           group.style.display = 'none';
//         }
//       });

//     });
//   });

// });




// document.addEventListener("DOMContentLoaded", function () {

//   const buttons = document.querySelectorAll('.target-btn');
//   const groups = document.querySelectorAll('.target-group');
//   const titles = document.querySelectorAll('.group-title');

//   buttons.forEach(button => {
//     button.addEventListener('click', function () {

//       const target = this.dataset.target;

//       // Toggle active button
//       buttons.forEach(btn => btn.classList.remove('active'));
//       this.classList.add('active');

//       // Switch product groups
//       groups.forEach(group => {
//         group.style.display = (group.dataset.group === target) ? 'grid' : 'none';
//       });

//       // Switch titles
//       titles.forEach(title => {
//         title.style.display = (title.dataset.title === target) ? 'inline' : 'none';
//       });

//     });
//   });

// });

// document.addEventListener("DOMContentLoaded", function () {

//   document.querySelectorAll('.target-btn').forEach(button => {

//     button.addEventListener('click', function () {
//       document.body.classList.add('page-loading');
//     });

//   });

// });


document.addEventListener("DOMContentLoaded", function () {

  // When going FROM 1X bundle TO 2X product
  document.querySelectorAll('.target-btn-2x').forEach(button => {

    button.addEventListener('click', function () {

      const currentProduct = this.dataset.currentProduct;

      if (currentProduct) {
        sessionStorage.setItem('last_1x_product', currentProduct);
      }

      document.body.classList.add('page-loading');

    });

  });


  // When on 2X product and clicking back to 1X
  document.querySelectorAll('.target-btn-1x').forEach(button => {

    button.addEventListener('click', function (e) {

      const savedProduct = sessionStorage.getItem('last_1x_product');

      if (savedProduct) {

        e.preventDefault();

        document.body.classList.add('page-loading');

        window.location.href = savedProduct;

      }

    });

  });

});